import React, { useState, createContext, useEffect, useContext } from 'react'
import TagManager from 'react-gtm-module'
import { useHistory, useParams } from 'react-router-dom'
import { Context } from '../Store'
import { toLower, parseInt, toString, upperFirst } from 'lodash'

export const StepContext = createContext()

export const StepProvider = (props) => {
  const [step, setStep] = useState(0)
  const [steps, setSteps] = useState([])
  const [state] = useContext(Context)
  const { property = {} } = state
  const history = useHistory()
  const { id, step: urlStep, bookingId } = useParams()
  useEffect(() => {
    const newStep = parseInt(urlStep)
    if (urlStep !== undefined && newStep !== step) {
      setStep(newStep)
    }
  }, [urlStep])
  const incrementStep = () => {
    if (props.pageType === 'visit') {
      TagManager.dataLayer({
        dataLayer: {
          event: 'asyncAction',
          gaHitType: 'event',
          category: 'funnel visit',
          action: 'visit',
          label: `step ${step + 1}`,
        },
      })
      history.push(`/property/visit/${id}/${step + 1}`)
    } else {
      TagManager.dataLayer({
        dataLayer: {
          event: 'eec',
          category: 'checkout',
          action: 'book',
          label: `step ${step + 1}`,
          ecommerce: {
            currencyCode: 'EUR',
            checkout: {
              actionField: {
                step: step + 1,
              },
              products: [
                {
                  id: toString(property.id),
                  price: toString(property.price),
                  brand: upperFirst(property.city),
                  category: property.type,
                  variant: '',
                  quantity: 1,
                  name: `${toLower(property.street)}, ${toLower(property.city)}, ${property.id}`,
                },
              ],
            },
          },
        },
      })
      history.push(`/bookings/${bookingId}/${step + 1}`)
    }
  }
  const decrementStep = () => {
    if (props.pageType === 'visit') {
      TagManager.dataLayer({
        dataLayer: {
          event: 'asyncAction',
          gaHitType: 'event',
          category: 'funnel visit',
          action: 'visit',
          label: `step ${step - 1}`,
        },
      })
      history.push(`/property/visit/${id}/${step - 1}`)
    } else {
      history.push(`/bookings/${bookingId}/${step - 1}`)
    }
  }
  const [canDecrement, setCanDecrement] = useState(false)
  useEffect(() => {
    setCanDecrement(step > 0)
  }, [step])
  return (
    <StepContext.Provider
      value={{
        step,
        setStep,
        incrementStep,
        decrementStep,
        steps,
        setSteps,
        canDecrement,
        setCanDecrement
      }}
    >
      {props.children}
    </StepContext.Provider>
  )
}
